export default "__VITE_ASSET__c636d334__"